import React, { Component } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import LrsClient from 'utils/lrs_client'
import { getToken } from 'utils'
import { isMobile } from 'react-device-detect'

class H5pParagraph extends Component {
  state = {
    fullscreen: false,
  }

  toggleFullscreen = () => {
    if (isMobile) {
      this.setState({ fullscreen: !this.state.fullscreen })
    }
  }

  handleContentRef = dom => {
    if (dom) {
      dom.onload = () => {
        try {
          let content = dom.contentWindow
          let h5pClass = content.H5P

          // Open in fullscreen when video is played.
          if (h5pClass.instances?.length && h5pClass.instances[0]?.video) {
            h5pClass.instances[0].video.on('stateChange', e => {
              if (e.data === 1) {
                this.toggleFullscreen()
              }
            })
          }

          // Integration with LRP.
          const lrp = new LrsClient.Lrp({
            userAccessToken: getToken(),
            platform: 'Trilhas',
          })
          lrp.enableH5PListener(content)
        } catch {
          console.log('UNABLE TO LISTEN H5p Iframe CONTENT WINDOW (CORS)')
        }
      }
    }
  }

  render() {
    const { h5p } = this.props
    if (!h5p) {
      return ''
    }
    const iframe = h5p.embed
    const iframeSrc = iframe.match(/(http.+\/embed)+/)[1]

    return (
      <iframe
        title='h5p-embed'
        ref={this.handleContentRef}
        src={iframeSrc}
        frameBorder='0'
        allowFullScreen='allowfullscreen'
      />
    )
  }
}

H5pParagraph.propTypes = {
  h5p: PropTypes.shape({
    embed: PropTypes.string.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment H5pParagraphFragment on ParagraphH5p {
      id
      h5p: fieldH5p {
        embed: h5pEmbed
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { H5pParagraph, fragments }
